module.exports = __webpack_public_path__ + "static/media/Cerrar sesion.b92e746b.svg";